import TunnelAnalytics from '../common/Segment.io/TunnelDom/TunnelAnalytics';

export const analytics = new TunnelAnalytics();
export default analytics;
